import * as Sentry from '@sentry/nextjs';
import { NEXT_PUBLIC_SENTRY_DSN } from '../config';

export const logError = (error: Error) => {
  if (NEXT_PUBLIC_SENTRY_DSN) {
    Sentry.captureException(error);
  } else if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line no-console
    console.log(error);
  }
};
